import { format, getHours, getMinutes } from "date-fns";
import { useEffect, useState, useRef } from "react";

function calculateMinutesFromStart(startHour, currentHour, currentMinute) {
  const startMinute = startHour * 60;
  const currentMinuteOfDay = currentHour * 60 + currentMinute;
  return currentMinuteOfDay - startMinute;
}

export function CurrentTime() {
  const currentTimeRef = useRef(null);
  const [scrolledIntoView, setScrolledIntoView] = useState(false);
  const [currentTimePos, setCurrentTimePos] = useState(null);
  const { startHour, endHour } = {
    startHour: 0,
    endHour: 23,
  };
  const timeFormat = "h:mm a";

  useEffect(() => {
    // Set the container scroll position based on the current time.

    const currentDateTime = new Date(); // Get current date and time in the specified timezone

    const currentHour = getHours(currentDateTime);
    const currentMinute = getMinutes(currentDateTime);

    if (currentHour > endHour || currentHour < startHour) {
      setCurrentTimePos(null);
    }
    const minutesFromStart = calculateMinutesFromStart(
      startHour,
      currentHour,
      currentMinute
    );
    setCurrentTimePos(minutesFromStart);

    if (!currentTimeRef.current || scrolledIntoView) return;
    // Within a small timeout so element has time to render.
    setTimeout(() => {
      currentTimeRef?.current?.scrollIntoView({ block: "center" });
      setScrolledIntoView(true);
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startHour, endHour, scrolledIntoView]);

  return (
    <div
      ref={currentTimeRef}
      className="absolute top-0 z-40 flex h-px items-center justify-center text-[10px] w-full"
      aria-hidden="true"
      style={{
        top: `calc(${currentTimePos}*var(--one-minute-height) + var(--calendar-offset-top))`,
        zIndex: 70,
      }}
    >
      <div className="w-14 pr-2 text-right bg-white">
        {format(new Date(), timeFormat)}
      </div>
      <div className="bg-black h-3 w-px" />
      <div className="bg-black h-px w-full" />
    </div>
  );
}
